import React, { useState, useContext, useMemo, useEffect } from "react";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import MarketsContext from "context/MarketsContext";
import _ from "lodash";
import styled from "styled-components";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import GetAppIcon from '@mui/icons-material/GetApp';
import AddMeters from "./AddMeters/AddMeters";
import EditMeters from "./EditMeters";
import UserService from "services/UserService";
import axios from "axios";
import { getMarketMeters } from "services/ConfigServices";
import { meters } from "variables/markets";
import { metersStatusData } from "variables/lists/markets";
import moment from "moment";
import DeleteMeters from "./DeleteMeters";
import { downloadCSV } from "utilities/exporttabletocsv";
import Button from "components/CustomButtons/Button.js";
import ExportTableToCSV from "components/ExportTableToCSV/ExportTableToCSV";

const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
`;

const TableName = styled.h1`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.3rem;
  font-weight: 500;
`;

export default function useMetersTable() {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const marketadmin = permis.includes("markets_admin");
  const markets_update = permis.includes("markets_update");
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = appContext;
  const marketContext = useContext(MarketsContext);
  const { market, setMarket } = marketContext;
  const [totalRows, setTotalRows] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const url = getMarketMeters(chartIdGroup, market.id);
  const [results, setResults] = useState({ meters: [] });
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [metersdata, setMetersData] = useState([]);
  const [marketmeters, setMarketmeters] = useState([]);

  const refreshTable = () => {
    setRefresh(!refresh);
  }

  //Ok but should not be able to change group at this level
  let prevIdGroup = ["0"];
  let prevRefresh = true;
  useEffect(() => {
    if (chartIdGroup && chartIdGroup[0] !== "0") {
      if ((prevIdGroup && prevIdGroup === chartIdGroup)
        && (prevRefresh && prevRefresh === refresh)) {
        return;
      }
      //setLoading(true);
      async function fetchData() {
        const response = await axios.get(
          url,
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        );
        setResults(response.data);
        setMetersData(response.data.meters);
        setLoading(false);
      }
      prevRefresh = refresh;
      prevIdGroup = chartIdGroup;
      fetchData();
    }
  }, [chartIdGroup, refresh]);

  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const SearchComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px", marginRight: "10px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  const filteredItems = _.get(results, `meters`, []).filter(
    (item) =>
      (item.parameters.meternumber && item.parameters.meternumber.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.status && metersStatusData.find((x) => x.id == item.parameters.status) && metersStatusData.find((x) => x.id == item.parameters.status).name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.datebegin && moment(item.parameters.datebegin).isValid() && moment(item.parameters.datebegin).format("DD/MM/YYYY").includes(filterText)) ||
      (item.parameters.dateend && moment(item.parameters.dateend).isValid() && moment(item.parameters.dateend).format("DD/MM/YYYY").includes(filterText)) ||
      (item.parameters.description && item.parameters.description.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.marketmembershipnumber && item.marketmembershipnumber.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.marketmembershipname && item.marketmembershipname.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.segment && item.segment.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.profil && item.profil.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.acheminement && item.acheminement.toLowerCase().includes(filterText.toLowerCase()))
  );

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };
    const onFilterText = (e) => setFilterText(e.target.value);
    let exportarray = marketmeters.map((item) => {
      let metertoexport = {};
      metertoexport[meters.meternumber] = item.parameters.meternumber;
      metertoexport[meters.status] = metersStatusData.find((x) => x.id == item.parameters.status)?.name;
      metertoexport[meters.datebegin] = (item.parameters.datebegin && moment(item.parameters.datebegin).isValid()) ? moment(item.parameters.datebegin).format("DD/MM/YYYY") : "";
      metertoexport[meters.dateend] = (item.parameters.dateend && moment(item.parameters.dateend).isValid()) ? moment(item.parameters.dateend).format("DD/MM/YYYY") : "";
      metertoexport[meters.description] = item.parameters.description;
      metertoexport[meters.marketmembershipnumber] = item.marketmembershipnumber;
      metertoexport[meters.marketmembershipname] = item.marketmembershipname;
      market?.parameters?.general?.energy === 'gas' &&
        (metertoexport[meters.profil] = item.profil || "");
      market?.parameters?.general?.energy === 'electricity' &&
        (metertoexport[meters.segment] = item.segment || "");
      market?.parameters?.general?.energy === 'electricity' &&
        (metertoexport[meters.acheminement] = item.acheminement || "");
      return metertoexport;
    });
    return (
      <>
        <SearchComponent
          key="SearchComponent"
          onFilter={onFilterText}
          onClear={handleClear}
          filterText={filterText}
        />
        {markets_update && (
          <>
            <UploadButton type="button" onClick={handleClear}>
              <AddMeters refetch={refreshTable} onClick={handleClear} marketmeters={marketmeters} />
            </UploadButton>
            <UploadButton type="button" onClick={handleClear}>
              <EditMeters refetch={refreshTable} onClick={handleClear} marketmeters={marketmeters} disabled={!marketmeters || marketmeters.length < 1} />
            </UploadButton>
            <UploadButton type="button" onClick={handleClear}>
              <DeleteMeters refetch={refreshTable} onClick={handleClear} marketmeters={marketmeters} disabled={!marketmeters || marketmeters.length < 1} />
            </UploadButton>
          </>
        )}
        <UploadButton type="button" onClick={handleClear}>
          <ExportTableToCSV dataarray={exportarray} disabled={!marketmeters || marketmeters.length < 1} />
        </UploadButton>
      </>
    );
  }, [filterText, resetPaginationToggle, metersdata, marketmeters]);

  return {
    gridState: {
      defaultPageSize: 10,
      data: filteredItems,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: subHeaderComponentMemo,
      loading,
    },
    refetch: refreshTable,
    setMarketmeters
  };
}
